var map = {
	"./bowls.jpg": 7956,
	"./pattern_bowl.jpg": 5518,
	"./potion_bottles.jpg": 1548,
	"./two_faced_effigies_back.jpg": 1132,
	"./two_faced_effigies_front.jpg": 4128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6578;